import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';
import SalesEstimateListPage from '../sales_estimate/SalesEstimateListPage';
import BuysEstimateListPage from '../buys_estimate/BuysEstimateListPage';

// 2026-10-11 메뉴 재편: 매출/매입 견적서 현황을 "견적서 현황" 한 메뉴 밑 탭으로 합쳤다.
// 각 탭은 기존 목록 화면을 그대로 그린다(변경 없음). 선택한 탭은 ?tab= 으로 기억해서
// 새로고침/뒤로가기/공유 링크에서도 유지된다.
const EstimateStatusPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') === 'buys' ? 'buys' : 'sales';

  const handleChange = (_event, next) => {
    const params = new URLSearchParams(searchParams);
    params.set('tab', next);
    setSearchParams(params);
  };

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
        <Tabs value={tab} onChange={handleChange} aria-label="견적서 현황 탭">
          <Tab value="sales" label="매출 견적서" />
          <Tab value="buys" label="매입 견적서" />
        </Tabs>
      </Box>
      {tab === 'buys' ? <BuysEstimateListPage /> : <SalesEstimateListPage />}
    </Box>
  );
};

export default EstimateStatusPage;
